import { initAntiphishingScript } from '@/tools/security-antiphising/iZoologicScript'

export function InjectAntiphishingScript() {
  initAntiphishingScript()
  return <></>
}
